import React, { useMemo, useState } from "react";
import { Button, Box } from "@mui/material";
import TabList from "@mui/lab/TabList";
import Tab from "@mui/material/Tab";
import { TabPanel } from "@mui/lab";
import TabContext from "@mui/lab/TabContext";
import { styled } from "@mui/material/styles";
import ServiceAlertPending from "./table/serviceAlertPending";
import ServiceAlertResponded from "./table/serviceAlertResponded";
import { getConfig } from "../../../../../../network/auth";
import axios from "axios";
import { baseUrl } from "../../../../../../network/constants/constants";
import ServiceAcceptPopup from "./servicePopups/serviceAcceptPopup";
import ServiceRejectPopup from "./servicePopups/serviceRejectPopup";
import SearchField from "../../../../../customComponent/searchField/searchField";

const ServiceAlert = ({
  servicePending,
  serviceResponded,
  fetchAlerts,
  setLoading,
}) => {
  const [tabValue, setTabValue] = useState("1");
  const [openAccept, setOpenAccept] = useState(false);
  const [openReject, setOpenReject] = useState(false);
  const [selectAlertId, setSelectAlertId] = useState(null);


  const [searchValue, setSearchValue] = useState("");

  const handleSearchChange = (event) => {
    setSearchValue(event.target.value);
  };

  const filteredServicePending = servicePending.filter(
    (service) =>
      service.business_name.toLowerCase().includes(searchValue.toLowerCase()) ||
        service.status.toLowerCase().includes(searchValue.toLowerCase()) ||
        service.category_name.toLowerCase().includes(searchValue.toLowerCase()) ||
        service.service_name.toLowerCase().includes(searchValue.toLowerCase())  
  );

  const displayServicePending = searchValue ? filteredServicePending : servicePending;

  const filteredServiceResponded = serviceResponded.filter(
    (service) =>
      service.business_name.toLowerCase().includes(searchValue.toLowerCase()) ||
        service.status.toLowerCase().includes(searchValue.toLowerCase()) ||
        service.category_name.toLowerCase().includes(searchValue.toLowerCase()) ||
        service.service_name.toLowerCase().includes(searchValue.toLowerCase())  
  );

  const displayServiceResponded = searchValue ? filteredServiceResponded : serviceResponded;

  const handleOpenAccept = (id) => {
    setSelectAlertId(id);
    setOpenAccept(true);
  };

  const handleCloseAccept = () => {
    setOpenAccept(false);
  };

  const handleOpenReject = (id) => {
    setSelectAlertId(id);
    setOpenReject(true);
  };

  const handleCloseReject = () => {
    setOpenReject(false);
  };

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  const config = useMemo(() => {
    return getConfig();
  }, []);

  const handleAdminResponse = (id, action) => {
    setLoading(true);

    const payload = {
      status: action === "accept" ? "Accepted" : "Rejected",
    };

    axios
      .put(`${baseUrl}superadmin/alerts-update/${id}/`, payload, {
        headers: {
          "Content-Type": "application/json",
          Authorization: config.headers.Authorization,
        },
      })
      .then((response) => {
        fetchAlerts();
      })
      .catch((error) => {
        console.error("Error updating request status:", error);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const StyledTab = styled(Tab)({
    "&.Mui-selected": {
      color: "#ff4d4d",
    },
  });

  const columns = [
    { field: "displayIndex", headerName: "No", width: 90 },
    { field: "id", headerName: "ID", width: 90 },
    { field: "status", headerName: "Status", width: 120 },
    { field: "business_name", headerName: "business Name", width: 160 },
    { field: "service_name", headerName: "service Name", width: 180 },
    { field: "category_name", headerName: "category Name", width: 160 },
    {
      field: "thumb",
      headerName: "Thumb",
      width: 140,
      renderCell: (params) => (
        <img
          src={`${baseUrl}${params.row.thumb}`}
          alt={params.row.thumb}
          style={{ width: "20%", height: "auto" }}
        />
      ),
    },
    { field: "description", headerName: "description", width: 200 },
    { field: "open_time", headerName: "open time", width: 110 },
    { field: "close_time", headerName: "close time", width: 110 },
    {
      field: "acceptReject",
      headerName: "Actions",
      width: 400,
      sortable: false,
      renderCell: (params) => (
        <>
          <Button
            variant="outlined"
            color="success"
            style={{ marginRight: "5px" }}
            onClick={() => handleOpenAccept(params.row.id)}
          >
            Accept
          </Button>
          <Button
            variant="outlined"
            color="error"
            style={{ marginRight: "5px" }}
            onClick={() => {
              handleOpenReject(params.row.id);
            }}
          >
            Reject
          </Button>
        </>
      ),
    },
  ];

  const respondedColumns = columns.filter(
    (column) => column.field !== "acceptReject"
  );

  return (
    <>
      <TabContext value={tabValue}>
        <Box
          sx={{
            flexGrow: 1,
            maxWidth: { xs: 650, sm: 1500 },
            bgcolor: "background.paper",
          }}
        >
          <TabList
            aria-label="lab API tabs example"
            onChange={handleTabChange}
            TabIndicatorProps={{
              style: {
                backgroundColor: "#ff4d4d",
              },
            }}
          >
            <StyledTab
              label="New request"
              sx={{ textTransform: "none" }}
              value="1"
            />
            <StyledTab
              label="Responded request"
              sx={{ textTransform: "none" }}
              value="2"
            />
          </TabList>
          <TabPanel value="1">
            <SearchField
              value={searchValue}
              handleSearchChange={handleSearchChange}
            />
            <ServiceAlertPending
              servicePending={displayServicePending}
              requestColumn={columns}
            />
          </TabPanel>
          <TabPanel value="2">
            <SearchField
              value={searchValue}
              handleSearchChange={handleSearchChange}
            />
            <ServiceAlertResponded
              serviceResponded={displayServiceResponded}
              respondedColumns={respondedColumns}
            />
          </TabPanel>
        </Box>
      </TabContext>
      <ServiceAcceptPopup
        open={openAccept}
        onClose={handleCloseAccept}
        handleAdminResponse={handleAdminResponse}
        selectAlertId={selectAlertId}
      />
      <ServiceRejectPopup
        open={openReject}
        onClose={handleCloseReject}
        handleAdminResponse={handleAdminResponse}
        selectAlertId={selectAlertId}
      />
    </>
  );
};

export default ServiceAlert;
